import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RegisterItemDecorator from './RegisterItemDecorator';
import { Link } from 'react-router';

class LabelImpl extends Component {
  static propTypes = {
    data: PropTypes.object,
  };

  render() {
    return (
      <Link to={`/ticket/ticketEshop/${this.props.data.id}`}>
        {this.props.data.name}
      </Link>
    );
  }
}

export default class LabelTicketEshop extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
  };

  render() {
    return (
      <RegisterItemDecorator
        resource={'ticketEshop'}
        resourceId={this.props.id}
        component={LabelImpl}
      />
    );
  }
}
